import { type Component, Show } from "solid-js";
import { twMerge } from "tailwind-merge";

const GRADIENT = "linear-gradient(90deg, #3853c2, #2840ab, #e5b84c, #c49a1a, #2840ab, #3853c2)";

/** Static (non-animated) brand gradient border, drawn behind a relative parent. */
export const GradientBorderStatic: Component<{
  inset?: number;
  class?: string;
  noGlow?: boolean;
}> = (props) => {
  return (
    <>
      <div
        style={{ inset: `${props.inset ?? -3}px`, background: GRADIENT }}
        class={twMerge("pointer-events-none absolute z-0 overflow-hidden rounded-lg", props.class)}
      />
      <Show when={!props.noGlow}>
        <div
          class={twMerge("pointer-events-none absolute z-0 overflow-hidden rounded-lg", props.class)}
          style={{ inset: "-1px", filter: "blur(8px)", background: GRADIENT }}
        />
      </Show>
    </>
  );
};
